import { render, staticRenderFns } from "./DataImport.vue?vue&type=template&id=edf4311c&scoped=true"
import script from "./DataImport.vue?vue&type=script&lang=js"
export * from "./DataImport.vue?vue&type=script&lang=js"
import style0 from "./DataImport.vue?vue&type=style&index=0&id=edf4311c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf4311c",
  null
  
)

export default component.exports